import PropTypes from 'prop-types';
import React from 'react';


const ErrorContext = React.createContext();

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  errors: PropTypes.object, // * example errors shape: { someDynamicKey: ['Some error message', 'Invalid message'] }
};

const defaultProps = {
  errors: {},
};

const Form = ({ children, errors, ...rest }) => (
  <ErrorContext.Provider value={errors}>
    <form {...rest} >
      { children }
    </form>
  </ErrorContext.Provider>
);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

Form.ErrorContext = ErrorContext;

export default Form;
